import axios from 'axios';
import { auth } from './firebase.js';

const api = axios.create({
  baseURL: 'http://127.0.0.1:8000',
});

// Request interceptor: attach Firebase ID token to every request
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      config.headers['Authorization'] = `Bearer ${token}`;
    } catch (e) {
      console.warn('[LeadsZoneMap API] Could not fetch auth token:', e.message);
    }
  }
  return config;
});

// Response interceptor: surface structured errors instead of silent crashes
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const data = error.response?.data;
    const message = typeof data?.detail === 'object' ? JSON.stringify(data.detail) : (data?.detail || data?.message || error.message || 'Erro desconhecido');

    const url = error?.config?.url || '';
    const isSilent = url.includes('/status') || url.includes('/results');

    if (!isSilent) {
      console.error(`[LeadsZoneMap API] ${status ?? 'NETWORK'} ${url} — ${message}`);
      toast.error(`Erro: ${message}`);
    }

    return Promise.reject(error);
  }
);

export default api;
